import { render, staticRenderFns } from "./fullscreen-loader.vue?vue&type=template&id=c64e5838&"
import script from "./fullscreen-loader.vue?vue&type=script&lang=js&"
export * from "./fullscreen-loader.vue?vue&type=script&lang=js&"
import style0 from "./fullscreen-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports